import { styled } from '@/styles/stitches.config';
import { ComposableStyledComponentProps } from '@/types/composable-styled-component';
import { CardProps } from '../card';
import { RelatedStory } from './related-story';
import { ShareButton, SharingProps } from './share';

type OutroProps = ComposableStyledComponentProps & {
  children: React.ReactNode;
  relatedStoryId: string | undefined;
  sharing: SharingProps;
};

const Root = styled('footer', {
  display: 'grid',
  gridTemplateColumns: '1fr',
  gridGap: '$6',
  alignItems: 'first baseline',
  justifyContent: 'center',
  paddingInline: '$4',
  '@bp8': {
    justifyContent: 'start',
    paddingBlockEnd: '$8',
    gridTemplateColumns: '1fr auto minmax(0, 25rem) 1fr',
    gridTemplateRows: 'repeat(2, auto)',
  },
});

const OutroText = styled('p', {
  gridColumn: 1,
  fontSize: '$3',
  fontWeight: '$semibold',
  color: 'var(--color-text-light)',
  lineHeight: '$3',

  '@bp8': {
    maxWidth: '30ch',
    fontSize: '$4',
    gridColumn: 2,
  },
});

export function Outro(props: OutroProps) {
  const { css, children, relatedStoryId, sharing } = props;

  return (
    <Root css={css}>
      <OutroText>{children}</OutroText>

      {sharing && (
        <ShareButton
          css={{
            gridColumn: 1,
            justifyContent: 'center',
            '@bp8': {
              gridColumn: 2,
              justifyContent: 'start',
            },
          }}
          {...sharing}
        />
      )}

      {relatedStoryId && (
        <RelatedStory
          id={relatedStoryId}
          css={{
            gridColumn: '1',
            alignItems: 'center',

            '@bp6': {
              gridColumn: '3',
              gridRow: '1 / -1',
            },
          }}
        />
      )}
    </Root>
  );
}
